import { InfiniteData, useQueryClient } from "@tanstack/react-query";
import { isArray, isEqual } from "lodash";
import { useCallback, useMemo } from "react";

export const useQuerySearch = <TResult extends { id: any } = {id: any}>({
  queryKey,
  entityId,
}: {
  queryKey: string;
  entityId?: any;
}) => {
  const queryClient = useQueryClient();

  const getListQueries = useCallback(() => {
    return queryClient
      .getQueryCache()
      .findAll()
      .filter(
        (query) =>
          isArray(query.queryKey) &&
          isEqual(query.queryKey.slice(0, 2), [queryKey, "list"])
      );
  }, [queryKey, queryClient]);

  const foundedEntity = useMemo(() => {
    if (entityId == null) {
      return undefined;
    }

    const value = queryClient.getQueryData<TResult>([queryKey, entityId]);

    if (value) {
      return value;
    }

    for (const query of getListQueries()) {
      const result = queryClient
        .getQueryData<InfiniteData<TResult[], unknown>>(query.queryKey)
        ?.pages?.flat()
        .find((item) => item.id === entityId);

      if (result) {
        return result;
      }
    }

    return undefined;
  }, [entityId, getListQueries, queryClient, queryKey]);

  return { foundedEntity };
};